<template>
	<div data-test="asset-details-asset-type">
		<h2 class="heading-5">Asset type</h2>
		<div class="asset-details-asset-type-module module p-150">
			<h3 class="heading-4">{{ props.data.name }}</h3>
			<div
				class="display-flex align-items-flex-start flex-direction-column-smo gap-300-md gap-100 mt-50 pt-25-smo text-color-gray-80"
			>
				<div class="flex-1 order-1-smo">{{ props.data.description }}</div>
				<img
					v-if="imageUrl"
					:src="imageUrl"
					:alt="props.data.name"
					class="asset-type-img"
					data-test="asset-details-asset-type-image"
				/>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { AssetType } from 'types/assets';
import { computed } from 'vue';

interface Props {
	data: AssetType;
}

const props = defineProps<Props>();

const imageUrl = computed((): string => props.data.image?.url ?? '');
</script>

<style lang="scss" scoped>
@use '../../../styles/utilities/respond-to.scss' as *;

.asset-details-asset-type-module {
	margin-top: 1rem;
}

.asset-type-img {
	width: 96px;
	height: 96px;

	@include respond-to(md) {
		width: 144px;
		height: 144px;
	}
}
</style>
